import axios from 'axios'
import dayjs from 'dayjs'
import { createApp } from 'vue'

const ID = 'js-pointHistory'
const LABELS_CAUSE = {
  BOOKMARK: '商品お気に入り登録',
  CALENDER: 'ギフトカレンダー登録',
  CALENDAR: 'ギフトカレンダー登録',
  CAMPAIGN_2025SUMMER: '夏の入会キャンペーン',
  EC_PURCHASE: 'お買い物（オンラインショップ）',
  EC_PURCHASE_CANCEL: '返金（オンラインショップ）',
  EXPIRED: '有効期限経過による失効',
  FAVORITE: '商品お気に入り登録',
  LOGIN: 'ログイン',
  RENEWAL_2024: '2024年9月会員制度リニューアル',
  REVIEW: '商品レビュー投稿',
  SIGNUP: '新規会員登録',
  STORE_PURCHASE: 'お買い物（店舗）',
  STORE_PURCHASE_CANCEL: '返金（店舗）',
  COLLECTED_HANDHELD_FAN: 'ハンディファン買い替えキャンペーン',
}

document.addEventListener('DOMContentLoaded', async () => {
  const element = document.getElementById(ID)
  if (!element) return

  const { baseUrl, customerId, hashedCustomerId } = element.dataset

  const fetch = async ({ size = 10, cursor = null } = {}) => {
    const pointsHistories = await axios.get(
      `${baseUrl}/customers/points_histories`,
      {
        withCredentials: true,
        params: {
          cursor,
          h: hashedCustomerId,
          id: customerId,
          size,
        },
      }
    )
    return pointsHistories.data
  }

  createApp({
    name: 'TemplatesCustomerAccountFun',
    data() {
      return {
        hasError: false,
        isLoading: true,
        nextPageCursor: null,
        pointsChangeHistories: [],
      }
    },
    async mounted() {
      await this.fetchPointHistory()

      this.$refs.retry.style.display = null
      this.$refs.list.style.display = null
      this.$refs.buttonShowMore.style.display = null
    },
    methods: {
      async fetchPointHistory() {
        this.isLoading = true
        this.hasError = false
        try {
          const { pointsChangeHistories, nextPageCursor } = await fetch({
            cursor: this.nextPageCursor,
          })
          pointsChangeHistories.forEach((pointHistory) => {
            this.pointsChangeHistories.push({
              ...pointHistory,
              dateText: dayjs(pointHistory.recordingDate).format(
                'YYYY年M月D日'
              ),
              reasonText:
                LABELS_CAUSE[pointHistory.pointsChangedReason] || 'その他',
            })
          })
          this.nextPageCursor = nextPageCursor
          this.isLoading = false
        } catch {
          this.hasError = true
          this.isLoading = false
        }
      },
      retry() {
        this.fetchPointHistory()
      },
    },
  }).mount(element)
})
